import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

/**
 * A generic details card that displays a set of data fields in a card layout.
 * Useful for displaying any type of entity data like members, payments, etc.
 */
const CommonDetailsCard = ({ title, data, excludedFields = [], fieldOrder = [] }) => {
  if (!data) return null;

  let fields = Object.entries(data).filter(
    ([key]) => !excludedFields.includes(key.toUpperCase())
  );

  if (fieldOrder.length > 0) {
    fields.sort(([aKey], [bKey]) => {
      const aIndex = fieldOrder.indexOf(aKey.toUpperCase());
      const bIndex = fieldOrder.indexOf(bKey.toUpperCase());

      if (aIndex === -1 && bIndex === -1) return 0;
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    });
  }

  return (
    <Card sx={{ mt: 2, width: '100%' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          {fields.map(([key, value]) => (
            <Box key={key}>
              <Typography variant="subtitle2" gutterBottom>
                {key.replaceAll("_", " ").toUpperCase()}
              </Typography>
              <Typography variant="body1" paragraph>
                {value ?? ""}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default CommonDetailsCard;